import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { routing} from './app-routing.module';
import { AppComponent } from './app.component';
import { MDBBootstrapModule, CheckboxModule, WavesModule, ButtonsModule, InputsModule, IconsModule, CardsModule } from 'angular-bootstrap-md';
import { LoginComponent } from './auth/login/login.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { NavbarComponent } from './main-layout/navbar/navbar.component';
import { FooterComponent } from './main-layout/footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MainLayoutComponent } from './main-layout/main-layout/main-layout.component'
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {AuthService} from "./auth/auth.service";
// RECOMMENDED
import { ModalModule } from 'ngx-bootstrap/modal';
// NOT RECOMMENDED (Angular 9 doesn't support this kind of import)

import {AuthGuard} from "./services/auth-guard.service";
import {ErrorDialogComponent} from "./shared/error-dialog/error-dialog.component";
import {WaitingDialogComponent} from "./shared/waiting-dialog/waiting-dialog.component";
import {SuccessDialogComponent} from "./shared/success-dialog/success-dialog.component";
import {ConfirmDialogComponent} from "./shared/confirm-dialog/confirm-dialog.component";
import {TokenInterceptor} from "./services/token-interceptor";
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import { ServiceWorkerModule } from '@angular/service-worker';
import { HttpModule } from '@angular/http';
import { environment } from '../environments/environment';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import {UploadFormComponent} from './cart-detail/add-to-cart/add-to-cart.component';
import {UploadErrorMsgComponent} from './shared/upload-error-msg/upload-error-msg.component';
import {ChangePasswordComponent} from './auth/change-password/change-password.component';
import { SafePipe } from './safe.pipe';
import { WaitingwhiteDialogComponent } from './shared/waitingwhite-dialog/waitingwhite-dialog.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDatepickerConfig, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgSelectConfig } from '@ng-select/ng-select'; 
import { ɵs } from '@ng-select/ng-select';
import { SortDialogComponent } from './product-list/sort-dialog/sort-dialog.component';
import { FilterDialogComponent } from './product-list/filter-dialog/filter-dialog.component';
import { ProductDetailPopupComponent } from './product-list/product-detail-popup/product-detail-popup.component';
import { DashboardComponent } from './homepage/dashboard/dashboard.component';
import { ResourcesComponent } from './resources/resources.component';
import { SchemePopupComponent } from './main-layout/scheme-popup/scheme-popup.component';
import { RbmPopupComponent } from './reports/rbm-popup/rbm-popup.component';
import { AbmPopupComponent } from './reports/abm-popup/abm-popup.component';
import { RsPopupComponent } from './reports/rs-popup/rs-popup.component';
import { ReportsComponent } from './reports/reports.component';
import { ReportsModule } from './reports/reports.module';
import { DdPopupComponent } from './reports/dd-popup/dd-popup.component';
import { IddPopupComponent } from './reports/idd-popup/idd-popup.component';
import { DownloadPopupComponent } from './product-list/download-popup/download-popup.component';
import { ImagePopupComponent } from './main-layout/image-popup/image-popup.component';
import { DirectDealerDownloadPopupComponent } from './product-list/dd-download-popup/dd-download-popup';
import { PopupWithoutConfirmComponent } from './shared/popup-without-confirm/popup-without-confirm.component';


// MDB Angular Free
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,DashboardComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    NavbarComponent,    FooterComponent, SafePipe,SortDialogComponent, FilterDialogComponent,
    MainLayoutComponent, ChangePasswordComponent, WaitingwhiteDialogComponent,
    DirectDealerDownloadPopupComponent, ConfirmDialogComponent, SuccessDialogComponent, WaitingDialogComponent,PopupWithoutConfirmComponent, ErrorDialogComponent, UploadFormComponent, UploadErrorMsgComponent, ProductDetailPopupComponent, ResourcesComponent, SchemePopupComponent, DownloadPopupComponent, ImagePopupComponent
  ],
  imports: [
    HttpClientModule, InfiniteScrollModule,
    ReactiveFormsModule,
    BrowserModule, routing,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    NgSelectModule,
    ModalModule.forRoot(),
    MDBBootstrapModule.forRoot(), BrowserAnimationsModule  , BsDatepickerModule.forRoot(),
    CheckboxModule, WavesModule, ButtonsModule, InputsModule, IconsModule, CardsModule, ReportsModule,
     ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
  ],
  providers: [ AuthService,  SafePipe,  NgSelectConfig , BsDatepickerConfig ,{
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor, 
    multi: true
  },ɵs,
    {provide: LocationStrategy, useClass: HashLocationStrategy}],
  bootstrap: [AppComponent],
  entryComponents: [ForgotPasswordComponent,DirectDealerDownloadPopupComponent, SortDialogComponent ,ImagePopupComponent, FilterDialogComponent,WaitingwhiteDialogComponent, ConfirmDialogComponent, ChangePasswordComponent, SuccessDialogComponent, UploadErrorMsgComponent, WaitingDialogComponent, ErrorDialogComponent, PopupWithoutConfirmComponent,UploadFormComponent, ProductDetailPopupComponent,SchemePopupComponent, RbmPopupComponent, AbmPopupComponent, RsPopupComponent, DdPopupComponent, IddPopupComponent, DownloadPopupComponent]
})
export class AppModule { }
